import React from 'react';
import ReactDOM from 'react-dom';
import StoriesSection from '../components/StoriesSection';
import { initializeI18n } from '../localization/i18n';
window.renderStoriesSection = (elementId, props) => {
  const el = document.getElementById(elementId);
  if (el) initializeI18n().then(() => ReactDOM.render(<StoriesSection props={props} />, el)).catch(() => {});
};
